import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "px-8 py-6" }
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col p-6 m-4 bg-white gap-2"
}
const _hoisted_4 = { class: "flex flex-col items-start mx-auto w-full gap-2" }
const _hoisted_5 = { class: "flex flex-row font-bold items-center justify-center gap-2" }
const _hoisted_6 = { class: "text-white font-normal rounded-md px-2" }
const _hoisted_7 = { class: "flex align-middle mx-5" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_9 = { class: "flex flex-row items-center justify-center gap-2" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "flex flex-row items-center justify-center gap-2" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "flex flex-row items-center justify-center gap-2" }
const _hoisted_14 = { class: "font-bold" }
const _hoisted_15 = { class: "flex flex-row items-center justify-center gap-2" }
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "min-h-52 flex flex-row gap-2" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  controls: ""
}
const _hoisted_21 = ["src", "type"]
const _hoisted_22 = ["src", "onClick"]
const _hoisted_23 = { class: "font-bold" }
const _hoisted_24 = { class: "flex flex-col gap-y-2" }
const _hoisted_25 = { class: "w-full flex flex-row" }
const _hoisted_26 = { class: "flex-1" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["src", "onClick"]
const _hoisted_29 = {
  key: 1,
  controls: ""
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "flex-1" }
const _hoisted_32 = { class: "py-2 flex gap-2" }
const _hoisted_33 = { class: "px-8 py-4 uppercase" }
const _hoisted_34 = { class: "mt-3 flex row justify-around" }
const _hoisted_35 = ["onSubmit"]
const _hoisted_36 = { class: "px-8 py-4 uppercase" }
const _hoisted_37 = { class: "mt-3 flex row justify-around" }
const _hoisted_38 = {
  class: "bg-blue-500 uppercase rounded-lg text-white p-2 w-32",
  type: "submit"
}

import { useRoute } from 'vue-router'
import { AxiosInstance } from 'axios'
import { inject, onMounted, ref } from 'vue'
import Navbar from '@/components/tools/Navbar.vue'
import { useStore } from 'vuex'
import router from '@/router'
import Toast from '@/components/tools/Toast.vue'
import DialogComponent from "@/components/doalog/DialogComponent.vue";
import ToolsUpload from '@/components/tools/Upload.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketManagerEdit',
  setup(__props) {

const form = ref()
const showCancelDialog = ref<boolean>(false);
const showUploadDialog = ref<boolean>(false);
const route = useRoute()
const axios = inject('$axios') as AxiosInstance

const ticketDetail = ref()
const clickupDetail = ref()
const commentsDetail = ref()
const isLoaded = ref<boolean>(false)
const comment = ref("")
const taskId = ref("")
const reason = ref("")
const toastConfig = ref({
  show: false,
  message: '',
  success: true,
  manual_close: false,
})

const openImage = (url: string) => {
  window.open(url)
}
const getPageData = async (id: string) => {
  isLoaded.value = false
  const { clickup, ticket } = await axios
    .post<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/${id}`)
    .then((response) => response.data)
  const comments = await axios
    .post<any>(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/${id}/comments`)
    .then((response) => response.data)


  ticketDetail.value = ticket
  clickupDetail.value = clickup
  taskId.value = clickup.id
  commentsDetail.value = comments

  console.log('[E] ~ getPageData ~ comments:', comments)
  isLoaded.value = true
}

const onClickComment = async () => {
  isLoaded.value = false
  try {
    const params = {
      taskId: taskId.value,
      comment: comment.value,
      userName: store.state.user.username
    }
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/create/comment`,
      params
    )
    comment.value = ''
    getPageData(`${route.params.id}`)
    isLoaded.value = true
  } catch (error) {
    isLoaded.value = true
    console.log(error)
  }

}

const onClickCancel = async () => {
  isLoaded.value = false
  try {
    const params = {
      taskId: taskId.value,
      reason: reason.value,
      userName: store.state.user.username
    }
    if(!reason.value){
      toastConfig.value.show = true
      toastConfig.value.success = false
      toastConfig.value.message = `Missing fields reason`
      toastConfig.value.manual_close = true
      isLoaded.value = true
      return false;
    }

    showCancelDialog.value = false;
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/action/cancel`,
      params
    )
    comment.value = ''
    reason.value = ''
    getPageData(`${route.params.id}`)
    isLoaded.value = true
  } catch (error) {
    isLoaded.value = true
  }

}

const onClickUpload = async () => {
  isLoaded.value = false
  try {
    

    const formData = new FormData(form.value)
    const attachmentsFile = formData.get('attachments') as File; 
    if (!attachmentsFile.size) {
      toastConfig.value.show = true
      toastConfig.value.success = false
      toastConfig.value.message = `Missing fields attachments`
      toastConfig.value.manual_close = true
      isLoaded.value = true
      return false;
    }
    if((attachmentsFile.size/ (1024 * 1024))>10 ){ //>10mb
      toastConfig.value.show = true
      toastConfig.value.success = false
      toastConfig.value.message = `ไฟลต้องไม่เกิน 10 MB`
      toastConfig.value.manual_close = true
      isLoaded.value = true
      return false;
    }
    showUploadDialog.value = false;
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/create/task-attachment`,
      formData
    )
    form.value = '';
    getPageData(`${route.params.id}`)
    isLoaded.value = true
  } catch (error) {
    isLoaded.value = true
  }

}
onMounted(async () => {
  const { id } = route.params
  await getPageData(id as string)
  if (ticketDetail.value.operatorId !== store.state.selectedOperator.operatorId) router.back()
})
const store = useStore()


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.ticketManagement.ticketManager')
    }, null, 8, ["title"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_font_awesome_icon, {
          class: "text-gray-500",
          icon: ['fas', 'circle-notch'],
          transform: "grow-6",
          spin: ""
        })
      ])
    ], 512), [
      [_vShow, !isLoaded.value]
    ]),
    (isLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.$t('messages.ticketManagement.ticketId')) + ": " + _toDisplayString(clickupDetail.value?.id) + " ", 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(clickupDetail.value?.status), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500",
                  style: {"width":"120px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showUploadDialog.value = true))
                }, _toDisplayString(_ctx.$t('messages.ticketManagement.uploadFile')), 1),
                _hoisted_8,
                _createElementVNode("button", {
                  type: "reset",
                  class: "flex-1 bg-red-500 text-white p-1 px-4 rounded",
                  style: {"width":"120px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showCancelDialog.value = true))
                }, _toDisplayString(_ctx.$t('messages.ticketManagement.cancelTicket')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('messages.ticketManagement.ticketTopic')) + ": ", 1),
              _createTextVNode(_toDisplayString(ticketDetail.value?.caseType), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('messages.ticketManagement.ticketName')) + ": ", 1),
              _createTextVNode(_toDisplayString(ticketDetail.value?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('messages.ticketManagement.ticketOwner')) + ": ", 1),
              _createTextVNode(_toDisplayString(ticketDetail.value?.adminUsername), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('messages.ticketManagement.ticketDescription')) + ": ", 1),
              _createTextVNode(" " + _toDisplayString(ticketDetail.value?.description), 1)
            ])
          ]),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('messages.ticketManagement.ticketImage')), 1),
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clickupDetail.value?.attachments, (image) => {
              return (_openBlock(), _createElementBlock("div", null, [
                (image.type == 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (image.mimetype.includes('video'))
                        ? (_openBlock(), _createElementBlock("video", _hoisted_20, [
                            _createElementVNode("source", {
                              src: image.url,
                              type: `video/${image.extension}`
                            }, null, 8, _hoisted_21)
                          ]))
                        : _createCommentVNode("", true),
                      (image.mimetype.includes('image'))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: image.url,
                            class: "w-52 h-52",
                            onClick: ($event: any) => (openImage(image.url_w_query))
                          }, null, 8, _hoisted_22))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('messages.ticketManagement.ticketComment')), 1),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commentsDetail.value, (comment) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createTextVNode(_toDisplayString(comment.message) + " ", 1),
                  (comment.attachmentList )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comment.attachmentList.split(','), (attachment) => {
                          return (_openBlock(), _createElementBlock("div", null, [
                            (!attachment.includes('.mp4'))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: attachment,
                                  class: "w-52 h-52 my-1",
                                  onClick: ($event: any) => (openImage(attachment))
                                }, null, 8, _hoisted_28))
                              : (_openBlock(), _createElementBlock("video", _hoisted_29, [
                                  _createElementVNode("source", {
                                    src: attachment,
                                    type: `video/mp4`
                                  }, null, 8, _hoisted_30)
                                ]))
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_31, _toDisplayString(new Date(comment.createdAt).toLocaleString('th')), 1)
              ]))
            }), 256)),
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((comment).value = $event)),
                name: "comment",
                type: "text",
                class: "w-full rounded-md"
              }, null, 512), [
                [_vModelText, comment.value]
              ]),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickComment())),
                class: "px-2 rounded-md border-2"
              }, _toDisplayString(_ctx.$t('messages.ticketManagement.send')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(DialogComponent, {
      title: "Confirm Cancel Ticket",
      isOpen: showCancelDialog.value,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (showCancelDialog.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t(`messages.ticketManagement.reason`)) + ": ", 1),
            _withDirectives(_createElementVNode("textarea", {
              class: "w-full rounded",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((reason).value = $event))
            }, null, 512), [
              [_vModelText, reason.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("button", {
            class: "bg-blue-500 uppercase rounded-lg text-white p-2 w-32",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (onClickCancel()))
          }, _toDisplayString(_ctx.$t(`messages.ticketManagement.confirm`)), 1),
          _createElementVNode("button", {
            class: "bg-red-600 rounded-lg uppercase text-white p-2 w-32",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (showCancelDialog.value = false))
          }, _toDisplayString(_ctx.$t(`messages.ticketManagement.cancel`)), 1)
        ])
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(DialogComponent, {
      title: "Upload File",
      isOpen: showUploadDialog.value,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (showUploadDialog.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          enctype: "multipart/form-data",
          ref_key: "form",
          ref: form,
          action: "",
          onSubmit: _withModifiers(onClickUpload, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("input", {
              name: "taskId",
              type: "text",
              class: "w-full rounded-md hidden",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((taskId).value = $event))
            }, null, 512), [
              [_vModelText, taskId.value]
            ]),
            _withDirectives(_createElementVNode("input", {
              name: "user_id",
              type: "text",
              class: "w-full rounded-md hidden",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(store).state.user.id) = $event))
            }, null, 512), [
              [_vModelText, _unref(store).state.user.id]
            ]),
            _withDirectives(_createElementVNode("input", {
              name: "operator_id",
              type: "text",
              class: "w-full rounded-md hidden",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(store).state.selectedOperator.operatorId) = $event))
            }, null, 512), [
              [_vModelText, _unref(store).state.selectedOperator.operatorId]
            ]),
            _createVNode(ToolsUpload)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", _hoisted_38, _toDisplayString(_ctx.$t(`messages.ticketManagement.confirm`)), 1),
            _createElementVNode("button", {
              class: "bg-red-600 rounded-lg uppercase text-white p-2 w-32",
              type: "button",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (showUploadDialog.value = false))
            }, _toDisplayString(_ctx.$t(`messages.ticketManagement.cancel`)), 1)
          ])
        ], 40, _hoisted_35)
      ]),
      _: 1
    }, 8, ["isOpen"]),
    _createVNode(Toast, {
      show: toastConfig.value.show,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((toastConfig.value.show) = $event)),
      message: toastConfig.value.message,
      success: toastConfig.value.success,
      manual_close: toastConfig.value.manual_close
    }, null, 8, ["show", "message", "success", "manual_close"])
  ], 64))
}
}

})